import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Container, Row, Col, Button, Alert } from 'react-bootstrap';
import useAdminData from '../../hooks/useAdminData';

//  Components
import { TextArea, TextInput, FileInput } from '../Inputs';
import Spinner from '../Spinner';

const NewTestimonialsForm = () => {
	//  API
	const { createTestimonial, error, isLoading } = useAdminData();
	const [success, setSuccess] = useState(false);

	return (
		<Formik
			initialValues={{
				name: '',
				title: '',
				text: '',
				profilePic: '',
			}}
			validationSchema={Yup.object({
				name: Yup.string()
					.max(40, '⚠️ Must have 40 characters, at most')
					.min(2, '⚠️ Must have 2 characters, at least')
					.required('⚠️ Mandatory'),
				title: Yup.string().required('⚠️ Mandatory'),
				text: Yup.string().required('⚠️ Mandatory'),
				profilePic: Yup.mixed().required('⚠️ Mandatory'),
			})}
			onSubmit={async (values, { setSubmitting }) => {
				let data = new FormData();
				data.append('name', values.name);
				data.append('profilePic', values.profilePic);
				data.append('title', values.title);
				data.append('text', values.text);

				await createTestimonial(data).then(() => {
					setSuccess(true);
					setSubmitting(false);
				});
			}}>
			{formik => (
				<Form className="mb-5 mt-4">
					<div className="form">
						<Container>
							<div className="form-box jumbotron jumbotron-fluid bg-light">
								<Container>
									<Row>
										<Col>
											<Container className="py-3">
												<Row className="mb-3">
													<Col xs={12} md={4}>
														<TextInput
															label="Name"
															name="name"
															type="text"
															placeholder="Name"
														/>
													</Col>
													<Col xs={12} md={4}>
														<TextInput
															label="Title"
															name="title"
															type="text"
															placeholder="Title"
														/>
													</Col>
													<Col xs={12} md={4}>
														<FileInput
															label="Image"
															name="profilePic"
															type="file"
															onChange={event => {
																formik.setFieldValue(
																	'profilePic',
																	event.target
																		.files[0]
																);
															}}
															accept="image/*"
														/>
													</Col>
												</Row>
												<Row>
													<Col>
														<TextArea
															label="Text"
															name="text"
															type="text"
															placeholder="Testimonial's text ..."
														/>
													</Col>
												</Row>
												<Row className="text-end">
													<Col>
														<Button
															type="submit"
															variant="primary"
															disabled={
																formik.isSubmitting ||
																!formik.isValid
															}
															className="fs-10">
															Create
														</Button>
													</Col>
												</Row>
												{formik.isSubmitting &&
													isLoading && (
														<Spinner color="red" />
													)}
												{success && (
													<Row className="text-center my-1">
														<Col>
															<Alert variant="success">
																Testimonial
																created
																successfully!
															</Alert>
														</Col>
													</Row>
												)}
												{error && (
													<Row className="text-center my-1">
														<Col>
															<Alert variant="danger">
																Error while
																creating new
																testimonial!
																<br />
																Cause: {error}
															</Alert>
														</Col>
													</Row>
												)}
											</Container>
										</Col>
									</Row>
								</Container>
							</div>
						</Container>
					</div>
				</Form>
			)}
		</Formik>
	);
};

export default NewTestimonialsForm;
